export const ChatOption = Object.freeze({
	avatar: 'avatar',
	call: 'call',
	extend: 'extend',
	leave: 'leave',
	leaveOwner: 'leaveOwner',
	mute: 'mute',
	rename: 'rename',
	send: 'send',
	userList: 'userList'
});